import { Component, ViewEncapsulation, inject } from "@angular/core";
import { CalendarDataService } from "@app/calendar/services/calendar-data.service";
import { WidgetFilterKey } from "./../../shared/models/WidgetFilterKey";
import { BaseWidget } from "./../BaseWidget";
import { CalendarmenuComponent } from "@app/calendar/pages/calendarmenu/calendarmenu.component";

@Component({
    selector: "calendar-widget",
    templateUrl: "./calendar-widget.component.html",
    styleUrls: ["./calendar-widget.component.scss"],
    encapsulation: ViewEncapsulation.None,
    imports: [CalendarmenuComponent],
})
export class CalendarWidgetComponent extends BaseWidget {
    private _calendarDS = inject(CalendarDataService);

    get showActions() {
        return this.getFilter(WidgetFilterKey.Calendar.ShowActions, false);
    }

    load() {
        super.load();
        this._calendarDS.loadCalendar();
    }
}
